export default __webpack_public_path__ + "static/media/navlogo.42f59938.svg";